const DeliveryAddress = ({ addresses, selectedAddress, setModalShow }: any) => {
  if (!addresses || addresses.length === 0) {
    return (
      <div className='no-address'>
        <button className='add-btn' onClick={() => setModalShow(true)}>
          + Add New Address
        </button>
      </div>
    );
  }

  const defaultAddress =
    selectedAddress ||
    addresses.find((addr: any) => addr.defaultAddress) ||
    addresses[0];

  return (
    <div className='address-container'>
      <div className='address-info'>
        <div className='address-header'>
          <input type='radio' checked readOnly />
          <span className='customer-name'>
            {defaultAddress.firstName} {defaultAddress.lastName}
          </span>
          <span className='address-badge'>{defaultAddress.addressType}</span>
        </div>
        <div className='address-details'>
          <p>
            <strong>Address: </strong>
            {defaultAddress.street1 && `${defaultAddress.street1}, `}
            {defaultAddress.street2 && `${defaultAddress.street2}, `}
            {defaultAddress.landmark && `${defaultAddress.landmark}, `}
            {defaultAddress.city && `${defaultAddress.city}, `}
            {defaultAddress.state && `${defaultAddress.state}, `}
            {defaultAddress.country && `${defaultAddress.country}`}
            {defaultAddress.pinCode && ` - ${defaultAddress.pinCode}`}
          </p>
          <p><strong>Contact: </strong> +91 {defaultAddress.contactNumber}</p>
        </div>
      </div>
      <button className='change-btn' onClick={() => setModalShow(true)}>Change</button>
    </div>
  );
};

export default DeliveryAddress;